(function () {
  const modal = document.querySelector('.video-lightbox');
  if (!modal) return;
  const mount = modal.querySelector('[data-video-mount]');
  let lastFocused = null;

  function open(type, src) {
    lastFocused = document.activeElement;
    mount.innerHTML = type === 'file'
      ? `<video src="${src}" controls autoplay playsinline></video>`
      : `<iframe src="${src}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Product video"></iframe>`;
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.video-lightbox__close').focus();
  }

  function close() {
    mount.innerHTML = '';
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.video-lightbox-open');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger.dataset.videoType, trigger.dataset.videoSrc);
      return;
    }
    if (e.target.closest('.video-lightbox__close') || e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) close();
  });
})();